import { render } from "./SupportSearchBox.vue?vue&type=template&id=03f011d0&scoped=true&ts=true"
import script from "./SupportSearchBox.vue?vue&type=script&lang=ts"
export * from "./SupportSearchBox.vue?vue&type=script&lang=ts"

import "./SupportSearchBox.vue?vue&type=style&index=0&id=03f011d0&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_eu_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03f011d0"]])

export default __exports__